var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkBookmarkActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3198 2H7.67982C5.54982 2 3.81982 3.74 3.81982 5.86V19.95C3.81982 21.75 5.10982 22.51 6.68982 21.64L11.5698 18.93C12.0898 18.64 12.9298 18.64 13.4398 18.93L18.3198 21.64C19.8998 22.52 21.1898 21.76 21.1898 19.95V5.86C21.1798 3.74 19.4498 2 17.3198 2ZM15.5098 9.75C14.5398 10.1 13.5198 10.28 12.4998 10.28C11.4798 10.28 10.4598 10.1 9.48982 9.75C9.09982 9.61 8.89982 9.18 9.03982 8.79C9.18982 8.4 9.61982 8.2 10.0098 8.34C11.6198 8.92 13.3898 8.92 14.9998 8.34C15.3898 8.2 15.8198 8.4 15.9598 8.79C16.0998 9.18 15.8998 9.61 15.5098 9.75Z",
    fill: "#92A1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBookmarkActive);
export default __webpack_public_path__ + "static/media/dark_bookmark_active.dad05be259a3b97abe7b52d5deec7289.svg";
export { ForwardRef as ReactComponent };